import { Currency } from '@/core/currency/interfaces';

const GBP: Currency = {
    name: 'Pound Sterling',
    demonym: 'Pound Sterling',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '826',
    symbol: '£',
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GBP',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default GBP;
